import { createContext, useEffect } from 'react'
import { PixelConstants } from '../constants/pixel';
import { useLocation } from 'react-router-dom';
import MetaPixel from 'react-facebook-pixel'
import ReactGA from "react-ga4";
import useEnvironment from '../hooks/useEnvironment';

export const PixelContext = createContext();

/**
 * Pixel Component context provider
 * 
 * Provides unified context for all pixels in app
 * 
 * Version 1.1 version with Meta Pixel and Google Analytics
 */
export const PixelProvider = ({ children }) => {
  const location = useLocation();
  const {isProduction} = useEnvironment();
  const isEnvironmentCorrect = !PixelConstants.ONLY_PRODUCTION_MODE || isProduction();
  const isGaSetUp = PixelConstants.GOOLGE.ANALYTICS_MEASUREMENT_ID && isEnvironmentCorrect;
  const Events = PixelConstants.EVENTS;

  const trackAnalyticsEvent = (eventName, eventParams) => {
    if (!isGaSetUp) {
      return;
    }
    
    eventParams = eventParams || null;

    if (!eventParams) {
      ReactGA.gtag('event', eventName);
    }
      ReactGA.gtag('event', eventName, eventParams);
  }

  useEffect(() => {
    if (PixelConstants.META.ID && isEnvironmentCorrect) {
      MetaPixel.init(PixelConstants.META.ID);
      MetaPixel.pageView();
    }

    if (isGaSetUp) {
      ReactGA.initialize(PixelConstants.GOOLGE.ANALYTICS_MEASUREMENT_ID);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])

  return (
    <PixelContext.Provider value={{ MetaPixel, ReactGA, trackAnalyticsEvent, Events }}>
      {children}
    </PixelContext.Provider>
  );
};
